import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {TheCrypt} from "../TheCrypt";
import {TheCryptSoundConfig} from "../configs/TheCryptSoundConfig";
import {TweenLite} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {TheCryptHelper} from "../utils/TheCryptHelper";

export class TheCryptSoundManager {
    private static _init: boolean;
    private static _newAvalanche: boolean;
    private static _wildFlashPlayed: boolean;
    private static _scatterFlashSoundPlayed: boolean;
    private static _bigWinEndSoundPlayed: boolean[] = ArrayHelper.initArrayWithValues(5, () => false);
    private static _reelLandingSoundId: number[] = [];
    private static _currentBigWinLevel: number = -1;
    private static currentLoop: string;
    public static countUpEndSoundPlayed: boolean;
    private static _reelLandingSounds: string[] = [];

    private static _scatterLandingPlayed: boolean;
    private static _wildLandingPlayed: boolean;
    private static _wildLandingSounds: string[] = [];
    private static _xWaysLandingPlayed: boolean;
    private static _xWaysLandingSounds: string[] = [];
    private static _wildNudgeSounds: string[] = [];
    private static _scatterAnticipationPlayed: boolean;
    private static _scatterAnticipationLandSounds: string[] = [];
    private static davidPanningReelStop: number[] = [-0.35, -0.25, -0.18, 0.01, 0.18, 0.25];

    private static get soundPlayer(): NolimitAudioPlayer {
        if (!this._init && NolimitConfig.isDevMode) {
            (<NolimitAudioPlayer>SlotGame.sound).showLogs(true);
            this._init = true;
        }
        return <NolimitAudioPlayer>SlotGame.sound;
    }

    public static fadeMusic(from: number, to: number, duration: number): void {
        // debugger;
        this.soundPlayer.fadeTrack({
            name: this.currentLoop,
            from: from,
            to: to,
            duration: duration
        });
    }

    public static fadeSoundEffect(name: string, from: number, to: number, duration: number): void {
        // debugger;
        this.soundPlayer.fadeTrack({
            name: name,
            from: from,
            to: to,
            duration: duration
        });
    }

    public static stopSoundEffect(name: string): void {
        this.soundPlayer.stopTrack(name);
    }

    public static playSound(name: string, repeat: number = 0): void {
        this.soundPlayer.playTrack({name: name, repeat: repeat});
    }

    public static stopAmbientLoop(dur: number = 200): void {
        if (this.currentLoop) {
            if (this.currentLoop.indexOf("fs") > -1) {
                this.stopSoundEffect(this.currentLoop);
            } else {
                const ambientLoop: NolimitHowl | undefined = this.soundPlayer.fadeTrack({
                    name: this.currentLoop,
                    from: 1,
                    to: 0,
                    duration: dur
                });
                ambientLoop && TweenLite.to(this, {duration: (dur / 1000)}).eventCallback("onComplete", () => {
                    this.stopSoundEffect(ambientLoop.soundName);
                });
            }
            this.currentLoop = "";
        }
    }

    public static playReelOut(): void {
        TheCryptSoundManager.playSound(TheCryptSoundConfig.REELS_OUT);
    }

    public static playReelIn(): void {
        this._reelLandingSoundId = [];
        TheCryptSoundManager.playSound(TheCryptSoundConfig.REELS_IN);
    }

    public static playScatterLandSound(id: number): void {
        if (this.isQuickStop) {
            if (!this._scatterLandingPlayed) {
                this._scatterLandingPlayed = true;
                const totalScattersLanded: number = TheCryptHelper.sum(TheCrypt.model.numberOfScattersOnReel) - TheCryptHelper.sum(TheCrypt.model.numberOfScattersOnReelPrev);
                if (totalScattersLanded < 4) {
                    TheCryptSoundManager.playSound(`scatter${totalScattersLanded}`);
                    return;
                }
                TheCryptSoundManager.playSound("scatter3");
                TheCryptSoundManager.playSound("scatterLand3Spins");
            }
            return;
        }

        if (TheCrypt.model.wasFeatureBuy) {
            const totalScattersLanded: number = parseInt(TheCrypt.model.buyFeatureName[9]);
            if (!this._scatterLandingPlayed) {
                this._scatterLandingPlayed = true;
                if (totalScattersLanded < 4) {
                    TheCryptSoundManager.playSound(`scatter3`);
                } else {
                    TheCryptSoundManager.playSound("scatter3");
                    TheCryptSoundManager.playSound("scatterLand3Spins");
                }
            } else if (id > totalScattersLanded) {
                TheCryptSoundManager.playSound("scatterLand3Spins");
            }
            return;
        }

        if (id < 4) {
            TheCryptSoundManager.playSound(`scatter${id}`);
            return;
        }
        TheCryptSoundManager.playSound("scatterLand3Spins");
    }

    public static playAnticipationLandingSound(id: number): void {
        if (this.isQuickStop && this._scatterAnticipationPlayed) {
            return;
        }
        this._scatterAnticipationPlayed = true;
        TheCryptSoundManager.playSound(this._scatterAnticipationLandSounds[id]);
    }

    public static playXWayLandingSound(id: number): void {
        if (this.isQuickStop && this._xWaysLandingPlayed) {
            return;
        }
        this._xWaysLandingPlayed = true;
        if (!this._xWaysLandingSounds || this._xWaysLandingSounds.length < 1) {
            if (NolimitConfig.isDevMode) {
                debugger;
            }
            return;
        }
        const soundName: string = this._xWaysLandingSounds.pop()!;
        TheCryptSoundManager.playSound(soundName);
    }

    public static playWildLandingSound(id: number): void {
        if (this.isQuickStop && this._wildLandingPlayed) {
            return;
        }
        this._wildLandingPlayed = true;
        TheCryptSoundManager.playSound(this._wildLandingSounds[id]);
        if (this._wildFlashPlayed) {
            return;
        }
        this._wildFlashPlayed = true;
        TheCryptSoundManager.playSound("wildFlash");
    }

    public static playNudgeSound(id: number, step: number): void {
        if (id > -1) {
            TheCryptSoundManager.playSound(TheCryptSoundConfig.WILD_NUDGE_FINAL[id]);
            return;
        }
        //debugger
        TheCryptSoundManager.playSound(this._wildNudgeSounds[step - 1]);
    }

    public static playLandingSound(reelId: number): void {
        const sound: NolimitHowl | undefined = this.soundPlayer.playTrack({
            name: this._reelLandingSounds[reelId],
            repeat: 0
        });
        if (sound) {
            sound.player.stereo(TheCryptSoundManager.davidPanningReelStop[reelId]);
        }
    }

    public static playScatterFlashSound(): void {
        if (this._scatterFlashSoundPlayed) {
            return;
        }
        this._scatterFlashSoundPlayed = true;
        TheCryptSoundManager.playSound("scatterFlash");
    }

    public static playCountUpStart(): void {
        TheCryptSoundManager.playSound("winCountup");
    }

    private static getAmbientSoundName(): string {
        let musicName: string;
        if (TheCrypt.model.isRestore) {
            musicName = TheCrypt.model.isNormal ? TheCryptSoundConfig.MAIN_GAME_AMBIANCE : TheCryptSoundConfig.FS_INTRO;
        } else {
            //fs1 or fs2
            const fsName: string = `fs${Math.ceil(Math.random() * 2)}`;
            musicName = TheCrypt.model.isNextNormal ? TheCryptSoundConfig.MAIN_GAME_AMBIANCE : fsName;
        }

        return musicName;
    }

    public static playAmbientLoop(duration: number = 200, name: string = "", volume: number = 1): void {
        name = name.length > 0 ? name : this.getAmbientSoundName();
        if (this.currentLoop === name) {
            return;
        }

        if (this.currentLoop) {
            this.stopAmbientLoop();
            this.playAmbientLoop(duration, name, volume);
        } else {
            this.currentLoop = name;
            this.soundPlayer.playTrack({name: this.currentLoop, volume: 0});
            this.soundPlayer.fadeTrack({
                name: this.currentLoop,
                from: 0,
                to: volume,
                duration: duration
            });
        }
    }

    public static playBigWinLevelSound(level: number): void {
        if (level === this._currentBigWinLevel) {
            return;
        }
        this._currentBigWinLevel = level;
        if (level === 0) {
            this._bigWinEndSoundPlayed = ArrayHelper.initArrayWithValues(5, () => false);
            TheCryptSoundManager.fadeMusic(1, 0, 1200);
        }
        TheCryptSoundManager.playSound(TheCryptSoundConfig.BIGWIN[level], 0);
    }

    public static playFSIntroSound(): void {
        TheCryptSoundManager.playSound("fsIntro");
        TheCryptSoundManager.playAmbientLoop(1000, TheCryptSoundConfig.FS_INTRO);
    }

    public static playWinCapMusic(): void {
        TheCryptSoundManager.playSound(TheCryptSoundConfig.WIN_CAP_MUSIC, 1000);
    }

    public static playMeterShowingSound(): void {
        this.playSound(`fsMeterFire`);
    }

    public static playBigWinEndSound(level: number): void {
        if (this._bigWinEndSoundPlayed[level]) {
            return;
        }
        TheCryptSoundManager.fadeMusic(0, 1, 1200);
        this._bigWinEndSoundPlayed[level] = true;
        this.stopSoundEffect(TheCryptSoundConfig.BIGWIN[level]);
        TheCryptSoundManager.playSound(TheCryptSoundConfig.BIGWIN_ENDS[level]);
        this._currentBigWinLevel = -1;
    }

    public static set newAvalanche(value: boolean) {
        this._newAvalanche = value;
        this._wildFlashPlayed = !value;
        this._wildLandingPlayed = !value;
        this._xWaysLandingPlayed = !value;
        this._scatterAnticipationPlayed = !value;
        this._scatterLandingPlayed = !value;
        this._scatterFlashSoundPlayed = !value;
        this._reelLandingSounds = ArrayHelper.shuffle(TheCryptSoundConfig.REEL_LANDING);
        this._wildLandingSounds = ArrayHelper.shuffle(TheCryptSoundConfig.WILD_LANDING);
        const sounds_xWays: string[] = ArrayHelper.shuffle(TheCryptSoundConfig.XWAYS_LANDING),
            sounds_anticipation: string[] = ArrayHelper.shuffle(TheCryptSoundConfig.SCATTER_LANDING),
            sounds_wildNudge: string[] = ArrayHelper.shuffle(TheCryptSoundConfig.WILD_NUDGE);
        this._xWaysLandingSounds = sounds_xWays.concat(sounds_xWays);
        this._scatterAnticipationLandSounds = sounds_anticipation.concat(sounds_anticipation);
        this._wildNudgeSounds = sounds_wildNudge.concat(sounds_wildNudge);
    }

    public static get isQuickStop(): boolean {
        return TheCrypt.apiPlugin.settings.get(APISetting.FAST_SPIN);
    }
}